// import { History } from 'history';

export interface Params {
  [key: string]: string | undefined;
}
export const updateUrlParams = (params: Params, history: any) => {
  const searchParams = new URLSearchParams();

  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== '') {
      searchParams.append(key, <string>params[key]);
    }
  }

  history.replace({ search: searchParams.toString() });
};
